module.exports = __webpack_public_path__ + "static/bill_small2-e18d8b9e888266893944d4d561a9a69b.png";